import {asyncType} from '../../../redux/helpers';

export const loginReducerKey = 'login';

export default {
   LOGIN: asyncType(`${loginReducerKey}/LOGIN`),
   LOGOUT: asyncType(`${loginReducerKey}/LOGOUT`),
   LOGOFF: asyncType(`${loginReducerKey}/LOGOFF`),
   CHANGE_PASSWORD: asyncType(`${loginReducerKey}/CHANGE_PASSWORD`),
   GET_CONNECTIONS: asyncType(`${loginReducerKey}/GET_CONNECTIONS`),
   FETCH_ITEMS_PERMISSIONS: asyncType(`${loginReducerKey}/FETCH_ITEMS_PERMISSIONS`),
   CLEAR_PERMISSIONS_ENTRY: `${loginReducerKey}/CLEAR_PERMISSIONS_ENTRY`,
};
